import { useEffect, useState } from 'react'
import { customerFormParamsLayoutService } from '../services/customer-form-layout.service'
import type { CustomerFormParamsLayout } from '../types/customer-form-layout.type'

export const useCustomerFormLayout = () => {
  const [customerFormLayout, setCustomerFormLayout] = useState<CustomerFormParamsLayout | null>(null)
  const [isLoadingLayout, setIsLoadingLayout] = useState(false)

  const fetchCustomerFormLayout = async () => {
    try {
      setIsLoadingLayout(true)
      const response = await customerFormParamsLayoutService({
        payload: { paramsType: 'cliente' }
      })
			if (response.status == 200) {
				const layout = typeof response.body === 'string' ? JSON.parse(response.body) : response.body
				setCustomerFormLayout(layout)
      }
    } catch (error) {
      console.error('Erro ao buscar layout do formulário:', error)
    } finally {
      setIsLoadingLayout(false)
    }
  }

  const getFieldConfig = (fieldName: string) => {
    if (!customerFormLayout?.geral) return null

    return customerFormLayout.geral.find(item =>
      item.campo === fieldName || item.fieldName === fieldName
    )
  }

  const isFieldVisible = (fieldName: string): boolean => {
    const config = getFieldConfig(fieldName)
    return config?.visible ?? true
  }

  const isFieldEnabled = (fieldName: string): boolean => {
    const config = getFieldConfig(fieldName)
    return config?.enabled ?? true
  }

  const getFieldLabel = (fieldName: string, defaultLabel: string): string => {
    const config = getFieldConfig(fieldName)
    return config?.label ?? defaultLabel
  }

  const getFieldMaxLength = (fieldName: string): number | undefined => {
    const config = getFieldConfig(fieldName)
    return config?.tamanhoCampo
  }

  useEffect(() => {
    fetchCustomerFormLayout()
  }, [])

  return {
    customerFormLayout,
    isLoadingLayout,
    isFieldVisible,
    isFieldEnabled,
    getFieldLabel,
    getFieldMaxLength,
    getFieldConfig,
    refetchLayout: fetchCustomerFormLayout
  }
}